import { Button, Badge, Skeleton } from "@chakra-ui/react";
import { TabsMenuOptionsRoutes } from "features/tenants/data/TabsMenuOptions";
// import useHasPermission from "core/features/permissions/hooks/useHasPermission";
import colors from "resources/theme/colors";

interface Option {
  label: string;
  icon?: any;
  route: TabsMenuOptionsRoutes;
  count?: number;
  loadingCount?: boolean;
  permissions: string[];
}

interface MenuDetalhesButtonProps {
  onChangeOption: (option: string) => any;
  option: Option;
  isSelected?: boolean;
  isDisabled?: boolean;
  light?: boolean;
}

function MenuDetalhesButton({
  option,
  isSelected,
  isDisabled,
  light,
  onChangeOption,
}: MenuDetalhesButtonProps) {
  // const hasPermission = useHasPermission(option.permissions);

  // if (!hasPermission) {
  //   return null;
  // }

  return (
    <Button
      key={option.route}
      w={light ? undefined : "100%"}
      py={light ? "12px" : "20px"}
      h="auto"
      gap={2}
      rounded={light ? 8 : 0}
      px={"16px"}
      fontSize={14}
      fontWeight="400"
      wordBreak="break-all"
      onClick={() => onChangeOption(option.route)}
      disabled={isDisabled}
      _disabled={{ backgroundColor: colors.white }}
      cursor={isDisabled ? "not-allowed" : undefined}
      mx={light ? 4 : 0}
      bg={isSelected ? (light ? colors.blue100 : colors.primary) : colors.white}
      color={
        isSelected
          ? light
            ? colors.primary
            : colors.white
          : isDisabled
          ? colors.smoke
          : undefined
      }
      textAlign="left"
      justifyContent="flex-start"
      _hover={
        isDisabled
          ? { backgroundColor: colors.white }
          : isSelected
          ? { backgroundColor: colors.primary }
          : undefined
      }
    >
      {option.icon}
      {option.label}

      {option.loadingCount ? (
        <Skeleton w="24px" h="16px" />
      ) : option.count !== undefined ? (
        <Badge>{option.count}</Badge>
      ) : null}
    </Button>
  );
}

export default MenuDetalhesButton;
